import { lazyPage } from '@/lib/lazy-load'

const OrgDetailMemberPage = lazyPage(() => import('./OrgDetailMemberPage'))
export default OrgDetailMemberPage
